import styles from './Checkbox.module.css';

export interface CheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string | undefined;
  disabled?: boolean;
  name?: string;
}

/** Vinkje met een tik-doel van minimaal 44 px (label meegerekend). */
export function Checkbox({ id, label, checked, onChange, hint, disabled, name }: CheckboxProps) {
  return (
    <div class={styles.field}>
      <label class={styles.row} for={id}>
        <input
          id={id}
          name={name ?? id}
          class={styles.box}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-describedby={hint ? `${id}-hint` : undefined}
          onChange={(e) => onChange((e.currentTarget as HTMLInputElement).checked)}
        />
        <span class={styles.label}>{label}</span>
      </label>
      {hint ? (
        <span id={`${id}-hint`} class={styles.hint}>
          {hint}
        </span>
      ) : null}
    </div>
  );
}
